import { render, staticRenderFns } from "./CustomerExams.vue?vue&type=template&id=2c967f34&scoped=true"
import script from "./CustomerExams.vue?vue&type=script&lang=js"
export * from "./CustomerExams.vue?vue&type=script&lang=js"
import style0 from "./CustomerExams.vue?vue&type=style&index=0&id=2c967f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c967f34",
  null
  
)

export default component.exports